import React from 'react';
import { Building2, Users, Brain, Calendar } from 'lucide-react';

/**
 * Компонент секции параметров учебного заведения
 */
const InstitutionParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  institutionTypes,
  aiIntegrationLevels
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Тип учреждения */}
      <div>
        <label htmlFor="institutionType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Building2 className="w-4 h-4 mr-2 text-indigo-500" />
          Тип учебного заведения
        </label>
        <select
          id="institutionType"
          name="institutionType"
          value={formData.institutionType}
          onChange={handleInputChange}
          className="form-select w-full"
        >
          {institutionTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.institutionType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.institutionType}
          </p>
        )}
      </div>

      {/* Количество студентов */}
      <div>
        <label htmlFor="studentsCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Users className="w-4 h-4 mr-2 text-indigo-500" />
          Количество студентов
        </label>
        <input
          type="text"
          id="studentsCount"
          name="studentsCount"
          value={formData.studentsCount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.studentsCount ? 'input-error' : ''}`}
          placeholder="Например: 5000"
        />
        {errors.studentsCount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.studentsCount}
          </p>
        )}
      </div>

      {/* Количество преподавателей */}
      <div>
        <label htmlFor="facultyCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Users className="w-4 h-4 mr-2 text-indigo-500" />
          Количество преподавателей
        </label>
        <input
          type="text"
          id="facultyCount"
          name="facultyCount"
          value={formData.facultyCount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.facultyCount ? 'input-error' : ''}`}
          placeholder="Например: 300"
        />
        {errors.facultyCount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.facultyCount}
          </p>
        )}
      </div>

      {/* Период внедрения */}
      <div>
        <label htmlFor="implementationPeriod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
          Период внедрения (месяцев)
        </label>
        <input
          type="text"
          id="implementationPeriod"
          name="implementationPeriod"
          value={formData.implementationPeriod}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.implementationPeriod ? 'input-error' : ''}`}
          placeholder="Например: 12"
        />
        {errors.implementationPeriod && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.implementationPeriod}
          </p>
        )}
      </div>

      {/* Уровень интеграции ИИ */}
      <div className="col-span-full">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <Brain className="w-4 h-4 mr-2 text-indigo-500" />
          Уровень интеграции ИИ
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
          {aiIntegrationLevels.map((level) => (
            <label 
              key={level.id} 
              className={`flex flex-col p-3 border rounded-lg cursor-pointer transition-colors
                ${formData.aiIntegrationLevel === level.id 
                  ? 'bg-indigo-50 border-indigo-300 dark:bg-indigo-900/20 dark:border-indigo-700' 
                  : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700'
                }`}
            >
              <div className="flex items-center mb-1">
                <input
                  type="radio"
                  name="aiIntegrationLevel"
                  value={level.id}
                  checked={formData.aiIntegrationLevel === level.id}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className={`ml-2 font-medium ${formData.aiIntegrationLevel === level.id ? 'text-indigo-700 dark:text-indigo-300' : 'text-gray-700 dark:text-gray-300'}`}>
                  {level.name}
                </span>
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400 ml-5">
                {level.description}
              </p>
            </label>
          ))}
        </div>
        
        {errors.aiIntegrationLevel && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.aiIntegrationLevel}
          </p>
        )}
      </div>
    </div>
  );
};

export default InstitutionParametersSection;